var PriceFormatPipeModuleModule = /** @class */ (function () {
    function PriceFormatPipeModuleModule() {
    }
    return PriceFormatPipeModuleModule;
}());
export { PriceFormatPipeModuleModule };
